import React from 'react';
import { theme } from '../../design/theme';
import { useAuth } from '../../context/AuthContext';
import { Company, UserRole } from '../../types';
import { useTenant } from '../../context/TenantContext';
import { useNavigate } from 'react-router-dom';

export const SelectCompanyPage: React.FC = () => {
  const { user } = useAuth();
  const { setCompany } = useTenant();
  const navigate = useNavigate();

  // Mock available companies (in a real app, this would be an API call)
  const availableCompanies: Company[] = [
    { companyId: 'comp-1', name: 'Acme Corp', subscriptionActive: true, tenantConfig: {} },
    { companyId: 'comp-2', name: 'Globex Corp', subscriptionActive: false, tenantConfig: {} },
  ];

  const handleSelect = (company: Company) => {
    setCompany(company);
    if (user?.role === UserRole.ENTERPRISE_ADMIN) {
      navigate('/enterprise/dashboard');
    } else {
      navigate('/super/dashboard');
    }
  };

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.colors.background.muted,
      padding: theme.spacing.lg
    }}>
      <div style={{
        width: '100%',
        maxWidth: '500px',
        backgroundColor: theme.colors.background.surface,
        padding: theme.spacing.xl,
        borderRadius: '12px',
        boxShadow: theme.shadows.lg,
        border: `1px solid ${theme.colors.neutral[200]}`
      }}>
        <h2 style={{ ...theme.typography.h2, textAlign: 'center', marginBottom: theme.spacing.lg }}>
          Select Company Context
        </h2>
        <p style={{ ...theme.typography.body, color: theme.colors.neutral[500], textAlign: 'center', marginBottom: theme.spacing.xl }}>
          You need to select a company to continue
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md }}>
          {availableCompanies.map(comp => (
            <button
              key={comp.companyId}
              onClick={() => handleSelect(comp)}
              style={{
                padding: theme.spacing.lg,
                backgroundColor: theme.colors.neutral[50],
                border: `1px solid ${theme.colors.neutral[200]}`,
                borderRadius: '8px',
                textAlign: 'left',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = theme.colors.brand.main;
                e.currentTarget.style.backgroundColor = theme.colors.brand.light;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = theme.colors.neutral[200];
                e.currentTarget.style.backgroundColor = theme.colors.neutral[50];
              }}
            >
              <div style={{ ...theme.typography.bodyBold, color: theme.colors.neutral[900] }}>{comp.name}</div>
              <div style={{ ...theme.typography.caption, color: theme.colors.neutral[500] }}>ID: {comp.companyId}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
